import baseTPLinkApi from "./BaseTPLinkApi";

export function updateSplashTimeout(data) {
  return baseTPLinkApi.request({
    url: "/update-splash-timeout/",
    method: "PUT",
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    data,
  });
}
